import { createContext } from 'react';
import type { CookiesStore } from 'store/useCookiesStore';
import type { StoreApi } from 'zustand';

export const CookiesStoreContext = createContext<StoreApi<CookiesStore> | null>(null);
